import React, {Suspense} from 'react';
import Loader from '../loader/Loader';

interface Props {}

const Loadable = (Component: React.FC) => (props: Props) => (
  <Suspense fallback={<Loader />}>
    <Component {...props} />
  </Suspense>
);

export default Loadable;
